import type * as api from '@gitbook/api-client';
import { BrandedDialogAside, useScreenType } from '@gitbook/spine-react';

import { IntegrationTileIcon } from './IntegrationTileIcon';

/**
 * Colorful branded aside for an integration dialog, showing the integration icon.
 */
export function IntegrationDialogAside(props: {
    integration?: api.Integration;
    backgroundSrc?: {
        light: string;
        dark: string;
    };
}) {
    const { integration, backgroundSrc } = props;
    const { isMobile } = useScreenType();

    return (
        <BrandedDialogAside backgroundSrc={backgroundSrc}>
            {integration ? (
                <div className="flex flex-1 flex-col items-start justify-start gap-6 p-3">
                    <IntegrationTileIcon size={isMobile ? 48 : 72} integration={integration} />
                    <div className="flex flex-col gap-3">
                        <h2 className="text-base text-ui-heading-medium">{integration.title}</h2>
                        <p className="text-secondary text-ui-base">{integration.description}</p>
                    </div>
                </div>
            ) : null}
        </BrandedDialogAside>
    );
}
